/**
 * OWLY CRM - Nuevos Leads Data con AI Fields
 * Leads diseñados para testing del sistema de alertas y AI
 */

import { Lead, AIInsights, ConversionFactors } from '@/types';
import { mockProjects, getUnitDisplay } from '../../projects';

const torreVerdeUnits = mockProjects[0]?.units || [];
const bosquesRioUnits = mockProjects[1]?.units || [];

export const nuevosLeads: Lead[] = [];
